"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/anchor-is-valid */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_router_dom_1 = require("react-router-dom");
const routes_1 = require("~/consts/routes");
const EditProfileDropdown_module_scss_1 = __importDefault(require("./EditProfileDropdown.module.scss"));
function EditProfileDropdown({ editHandler }) {
    const { t } = (0, react_i18next_1.useTranslation)('profile');
    return (react_1.default.createElement("div", { className: EditProfileDropdown_module_scss_1.default.dropdown },
        react_1.default.createElement(react_router_dom_1.Link, { to: "", onClick: editHandler }, t('edit-dropdown.details')),
        react_1.default.createElement(react_router_dom_1.Link, { to: routes_1.CHANGE_EMAIL, replace: true }, t('edit-dropdown.email')),
        react_1.default.createElement(react_router_dom_1.Link, { to: routes_1.CHANGE_PASSWORD, replace: true }, t('edit-dropdown.password'))));
}
exports.default = EditProfileDropdown;
